export default {
  countCells: 5,
  massive: [
    {
      dataField: 'region',
      cols: 1,
      rows: 1,
      text: 'Субъекты РФ',
      class: 'd-flex align-center  ',
      headerClass: '  ',
      headerStyles: `min-width: 210px;`,
      order: 0,
      variable: true,
      template: (r) => r?.name ?? ''
    },
    {
      dataField: 'downloadExcel',
      cols: 1,
      rows: 1,
      text: `Выгрузка данных субъекта РФ`,
      class: `d-flex flex-row justify-center  pl-2 `,
      headerClass: ' ',
      headerStyles: `justify-items: center`,
      order: 1,
      variable: true,
    },
    {
      dataField: 'approvalFile',
      cols: 1,
      rows: 1,
      order: 3,
      variable: true,
      class: `d-flex  flex-column  justify-center pl-2`,
      headerStyles: `justify-items: center`,
      headerClass: '',
      text: `Подписанные данные субъекта РФ`,
    },
    {
      dataField: 'uploadScan',
      cols: 1,
      rows: 1,
      text: `Загрузить сопроводительное письмо`,
      class: `d-flex  flex-column  justify-center pl-2`,
      headerClass: ' ',
      headerStyles: `justify-items: center`,
      order: 4,
      variable: true,
    },
    {
      dataField: 'status',
      cols: 1,
      rows: 1,
      text: `Статус согласования`,
      class: `d-flex  flex-column  justify-center pl-2`,
      headerClass: ' ',
      headerStyles: `justify-items: center`,
      order: 4,
      variable: true,
    },
  ]
}
